import LDClient from "launchdarkly-js-client-sdk"
import { runtimeEnv } from '@/utils/runtimeEnv'

// Automated end-to-end runs inject a flag map on `window.__E2E_FEATURE_FLAGS__`
// (the same global the modern web-next helper reads). When it is present we
// resolve flags from that map instead of the LaunchDarkly browser SDK, so a
// test can force a company-scoped flag on/off deterministically. The global is
// never set outside a test run, so production behavior is unchanged.
const e2eFeatureFlags = () =>
  (typeof window !== 'undefined' && window.__E2E_FEATURE_FLAGS__) || null

// Identifies these browser packs to LaunchDarkly so LD attributes their
// service connections to `spectora-web`, separately from the Rails server
// SDK's `spectora-rails` (config/initializers/launchdarkly.rb).
//
// No version is reported: nothing exposes a commit SHA to this bundle, and an
// empty or malformed version would make the SDK discard the id along with it.
const LD_APPLICATION = { id: 'spectora-web' }

let client
let isClientReady = false
const getClient = (company, onReadyCallback) => {
  // Under an e2e override the LaunchDarkly client may never initialize (no
  // client id in the test environment), so its `ready` event would never fire
  // and the caller's readiness callback would hang. Resolve readiness on the
  // next microtask and skip initializing the real client — flag reads go
  // through the override map in `enabledForCompany`.
  if (e2eFeatureFlags()) {
    if (onReadyCallback) {
      Promise.resolve().then(onReadyCallback)
    }
    return client
  }

  const context = {
    kind: 'company',
    key: `company_${company.id}`,
    is_free_trial: !company.attributes?.paid,
  }

  if (!client) {
    client = LDClient.initialize(runtimeEnv('LAUNCHDARKLY_CLIENT_ID'), context, {
      application: LD_APPLICATION,
    })
    client.on('ready', () => {
      isClientReady = true
      if (onReadyCallback) {
        onReadyCallback()
      }
    })
  } else if(onReadyCallback){
     if(isClientReady){
      onReadyCallback()
    } else {
      client.on('ready', onReadyCallback)
    }
  }

  return client
}

const LdFeatures = {
  install(Vue, opts = {}) {
    Vue.prototype.$ldFeatures = {
      getClient,
      enabledForCompany: (feature, company) => {
        const overrides = e2eFeatureFlags()
        if (overrides) {
          return Object.prototype.hasOwnProperty.call(overrides, feature)
            ? overrides[feature]
            : false
        }

        if (!company) return

        return getClient(company).variation(feature, false)
      },
    }
  },
}

export default LdFeatures
